import React from 'react';
import styles from './Layout.module.css';

const Layout = ({ children, width = '1440px' }) => {
  return (
    <div className={styles.layout} style={{ maxWidth: width }}>
      <div className={styles.canvas}>
        <div className={styles.contentStack}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;